import { ApiGetRequest } from './api-get-request';

export class GetTokenFromCookieRequest extends ApiGetRequest
{
    public constructor(webapiBasepath: string)
    {
        super('/authorize/GetTokenFromCookie', undefined, null, webapiBasepath);
    }
}
